
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { CustomerRegister } from '@/lib/models/CustomerRegister'

import BacRouterLinkOrA from '@/components/BacRouterLinkOrA.vue'
import BacModal from '@/components/BacModal.vue'
import BacButton from '@/components/BacButton.vue'
import BacLazyImage from '@/components/BacLazyImage.vue'

import { Team } from '../lib/models/Team'
import UIkit from 'uikit'
import { ShopDonate } from '../lib/models/ShopDonate'
import { User } from '../lib/models/User'

@Component({
  components: {
    BacRouterLinkOrA,
    BacModal,
    BacButton,
    BacLazyImage
  }
})
export default class BacRodeoTile extends Vue {
    @Prop({ default: null }) registerRallyRound!: CustomerRegister | null;
    @Prop({}) user!: User;

    @Prop({ default: false }) customTile!: boolean
    @Prop({ default: false }) openNewTab!: boolean
    @Prop({ default: '' }) customLink!: string
    @Prop({ default: '' }) customLogoPath!: string
    @Prop({ default: '' }) customRallyBackgroundPath!: string
    @Prop({ default: '' }) rodeoName!: string
    @Prop({ default: '' }) rodeoRoundName!: string

    rallyLogoPath = ''
    team: Team = new Team()
    charities: ShopDonate[] = []
    isTeamlead = false

    charityModalId = 'charity-modal-' + Math.round(Math.random() * 100000)
    charityDismissed = false

    mounted () {
      this.$store.dispatch('loadLoggedInUser')
      this.loadRallyLogoPath()
      if (!this.customTile) {
        // this.loadTeam()
        this.checkIfTeamlead()
      }
    }

    get rodeoDate () {
      const round = this.registerRallyRound && this.registerRallyRound.rallies.length && this.registerRallyRound.rallies[0].rounds.length && this.registerRallyRound.rallies[0].rounds[0]
      if (!round) {
        return ''
      }
      return `
            ${new Date(round.dateBegin).getDate().toString().padStart(2, '0')}.${(new Date(round.dateBegin).getMonth() + 1).toString().padStart(2, '0')}.
      -
      ${new Date(round.dateEnd).getDate().toString().padStart(2, '0')}.${(new Date(round.dateEnd).getMonth() + 1).toString().padStart(2, '0')}.${new Date(round.dateEnd).getFullYear()}
      `
    }

    get rallyOrParentId () {
      if (!this.registerRallyRound) {
        return -1
      }
      return this.registerRallyRound.customerRegisterParentId ? this.registerRallyRound.customerRegisterParentId : this.registerRallyRound.id
    }

    @Watch('user')
    async checkIfTeamlead () {
      if (!this.registerRallyRound || !this.registerRallyRound.teamId || !this.user) {

      }
      // this.isTeamlead = await this.user.isTeamlead(this.registerRallyRound.teamId)
    }

    saveToLocalStorage (e: Event) {
      // show choose charity modal
      /* ACTIVATE THIS FOR CHARITY POPUP BAC-274
      if (!this.charityDismissed && this.isTeamlead && !this.team.charityId && this.registerRallyRound.status === 2) {
        e.preventDefault()
        UIkit.modal('#' + this.charityModalId).show()
        this.team.charityId = this.registerRallyRound.rallies[0].rounds[0].shop_donate_id
        this.loadCharities()
        return
      } */

      if (!this.registerRallyRound) {
        return
      }

      window.localStorage.setItem('registerStateLink', `/register-state/${this.rallyOrParentId}`)
      window.localStorage.setItem('teamareaLink', `team.menu.php?rid=${this.registerRallyRound.rallies[0].id}&rrid=${this.registerRallyRound.rallies[0].rounds[0].id}`)
      if (this.registerRallyRound.teamId) {
        window.localStorage.setItem('tid', this.registerRallyRound.teamId.toString())
      }
      if (this.registerRallyRound.rallyId) {
        window.localStorage.setItem('rid', this.registerRallyRound.rallyId.toString())
      }
      if (this.registerRallyRound.rallyRoundId) {
        window.localStorage.setItem('rrid', this.registerRallyRound.rallyRoundId.toString())
      }
    }

    get tileHref () {
      if (!this.registerRallyRound) {
        return ''
      }
      switch (this.registerRallyRound.status) {
        case 0:
          return `/register-state/${this.rallyOrParentId}`
        case 1:
          return `/create-team/${this.rallyOrParentId}`
        case 2:
          return `/base/${this.registerRallyRound.rallies[0].rounds[0].id}`
        case 4:
          return `/register-state/${this.rallyOrParentId}`
      }
      return ''
    }

    get isHiddenState () {
      if (!this.registerRallyRound) {
        return false
      }
      if (this.registerRallyRound.status === 3) {
        return true
      }
      return false
    }

    async loadRallyLogoPath () {
      if (this.registerRallyRound) {
        const image = await import(`@/assets/img/rally/rounds/logos/${this.registerRallyRound.rallies[0].rounds[0].logo}`)
        // const image = await import('@/assets/img/rally/2.png')
        this.rallyLogoPath = image.default
      } else {
        this.rallyLogoPath = (await import(`@/assets/img/rally/rounds/logos/${this.customLogoPath}`)).default
      }
    }

    async loadTeam () {
      if (!this.registerRallyRound) {
        return
      }
      if (!this.registerRallyRound.teamId) {
        return
      }
      this.team = await Team.get(this.registerRallyRound.teamId)
    }

    async loadCharities () {
      this.charities = await ShopDonate.getAll({})
    }

    async saveTeam () {
      await this.team.update()
    }

    get Status () {
      if (this.registerRallyRound) {
        return this.registerRallyRound.status
      } else { return '' }
    }
}
